import { render, staticRenderFns } from "./FormBuilderInnerPlain.vue?vue&type=template&id=cf56db26&"
import script from "./FormBuilderInnerPlain.vue?vue&type=script&lang=js&"
export * from "./FormBuilderInnerPlain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports